/* istanbul ignore file */
// TODO: Create test file

import $http from '@vue-util/http';
import { Cookie } from '@common-vue/util/src/modules/cookie';

/**
 * A global request functionality that fetch & return xapi data
 *
 * @returns
 */
export default function requestUtil() {
  const config = {
    paths: {
      product: '/xapi/digital/v1/product',
    },
  };

  const axiosSettings = {
    params: {
      _regionCode: Cookie.get('shippingCountry', false, false) || 'US',
      currencyCode: Cookie.get('currency', false, false) || 'USD',
      // this help us to dealing with just the simple version of the data
      // without having to worry about Master/Consolidate/LatchKey stuff
    },
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 8000,
  };

  const getXapiProduct = async (productId = null) => {
    if (!productId) throw new Error('Product ID is required for xapi request!');

    const baseURL = `${config.paths.product}/${productId}`;
    const api = $http.create({ baseURL });

    // Checking (res.data) type for/when product is not available.
    // The data could be none-object type... eg: html
    try {
      return api.get('', { ...axiosSettings })
        .then((res) => (typeof res.data === 'object' ? res.data : null));
    } catch (e) {
      console.warn(e.message()); // eslint-disable-line no-console
      return null;
    }
  };

  return {
    getXapiProduct,
  };
}
